import React from "react";
import { Card } from "./ui/card";
import { MessageCircle, Clock, CheckCircle } from "lucide-react";

const HowItWorks = ({ language }) => {
  const content = {
    es: {
      title: "Cómo funciona",
      subtitle: "Tres pasos sencillos para resolver tu problema",
      steps: [
        {
          icon: MessageCircle,
          number: "1",
          title: "Envíame fotos por WhatsApp",
          description: "Manda fotos del trabajo y cuéntame qué necesitas",
        },
        {
          icon: Clock,
          number: "2",
          title: "Te doy precio y hora",
          description: "Te confirmo el presupuesto y cuándo puedo ir",
        },
        {
          icon: CheckCircle,
          number: "3",
          title: "Voy y lo dejo listo",
          description: "Hago el trabajo rápido y profesional",
        },
      ],
    },
    en: {
      title: "How it works",
      subtitle: "Three simple steps to solve your problem",
      steps: [
        {
          icon: MessageCircle,
          number: "1",
          title: "Send photos on WhatsApp",
          description: "Send photos of the job and tell me what you need",
        },
        {
          icon: Clock,
          number: "2",
          title: "I confirm price & time",
          description: "I'll confirm the quote and when I can come",
        },
        {
          icon: CheckCircle,
          number: "3",
          title: "I come and get it done",
          description: "I do the job fast and professionally",
        },
      ],
    },
  };

  const currentContent = content[language];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {currentContent.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {currentContent.subtitle}
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
          {currentContent.steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <Card
                key={index}
                className="step-card p-8 bg-white border border-gray-200 rounded-xl shadow-sm relative"
              >
                {/* Step Number Badge */}
                <div className="absolute -top-4 left-8 w-12 h-12 bg-[#2563EB] text-white rounded-full flex items-center justify-center text-xl font-bold shadow-lg">
                  {step.number}
                </div>

                <div className="flex flex-col items-center text-center pt-6">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4">
                    <IconComponent className="w-8 h-8 text-[#2563EB]" />
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {step.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600">{step.description}</p>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
